// New color palette
// blue
export var blue800 = '#2a57ec';
export var blue700 = '#206cff';
export var blue500 = '#008dff';
export var blue400 = '#558FFF';
export var blue300 = '#4fb1ff';
export var blue200 = '#89c8ff';
export var blue10 = '#e6f3ff'; // dark blue

export var darkBlue900 = '#10275B';
export var darkBlue800 = '#1b3772';
export var darkBlue700 = '#0B1A3B';
export var darkBlue400 = '#344773';
export var darkBlue300 = '#57678C';
export var darkBlue100 = '#BDBECD';
export var darkBlue10 = '#D4D8E1'; // teal

export var teal500 = '#14C4CA';
export var teal200 = '#89E1E4';
export var teal100 = '#B8EDEF';
export var teal50 = '#E7F9F9'; // red

export var red700 = '#d40033';
export var red400 = '#ef3f54';
export var red200 = '#ee939b';
export var red10 = '#fff8f9'; // green

export var green800 = '#00782e';
export var green400 = '#2eb769';
export var green300 = '#5dc483';
export var green200 = '#8fd4a7';
export var green10 = '#eef6f4'; // yellow

export var yellow800 = '#ff8a00';
export var yellow400 = '#fec802';
export var yellow300 = '#ffdf6b';
export var yellow200 = '#fede7b';
export var yellow10 = '#fef9e5'; // purple

export var purple600 = '#8d24aa';
export var purple400 = '#ab47bc';
export var purple300 = '#ba68c8';
export var purple200 = '#ce93d8';
export var purple10 = '#eee4f3'; // gray

export var gray900 = '#212121';
export var gray800 = '#424242';
export var gray700 = '#616161';
export var gray600 = '#757575';
export var gray500 = '#9e9e9e';
export var gray400 = '#bdbdbd';
export var gray300 = '#e0e0e0';
export var gray200 = '#eeeeee';
export var gray100 = '#f5f5f5';
export var gray50 = '#fafafa'; // blueGray

export var blueGray700 = '#2B3A47';
export var blueGray500 = '#3e4e5d';
export var blueGray400 = '#77838D';
export var blueGray300 = '#949FA8';
export var blueGray100 = '#B7BECD';
export var blueGray50 = '#F3F5F7';
export var blueGray10 = '#F5F9FF'; // white

export var white = '#ffffff'; // Legacy color palette
// blue

export var blue = blue700;
export var blueBorder = '#239ed8';
export var blueDark = blue700;
export var blueHover = '#085174';
export var blueContact = '#a8d5eb';
export var blueLight = '#d4ecf7';
export var blueLightBorder = '#48bdf3';
export var blueDarkTheme = '#4bbdf3'; // gray scale

export var black = gray900;
export var blackDark = '#000000';
export var grayDarkest = '#515c61';
export var grayDarker = '#556268';
export var grayDark = blueGray400;
export var muted = blueGray500;
export var gray = '#d1d8db';
export var grayLight = '#e3e8eb';
export var grayLighter = '#eef1f3';
export var grayLightest = '#f4f6f7'; // basic

export var green = green400;
export var greenDark = '#4aa666';
export var yellow = yellow400;
export var yellowLight = '#ffe9ab';
export var yellowDark = '#dfa600';
export var red = red400;
export var redDark = '#e02a2a';
export var purple = purple400; // gfh colors

export var gfhBlue = '#1B74DA';
export var gfhGreen = '#2FCFAC';
export var gfhRed = '#E75C66';